import React, { Fragment } from 'react';
import fr from 'facet-rest';
import { FDStack, FDTooltip } from '@facet-wealth/design';
import { StepConnector, StepIcon } from '@material-ui/core';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export function Stepper({ collection }) {
  const steps = collection.resources().list();
  const theme = useTheme();
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  return (
    <FDStack direction="row" alignItems="center" justifyContent="center" spacing={1} paddingX={3} width="100%">
      {steps.map((step, i) => (
        <Fragment key={step.id()}>
          <FDTooltip title={step.attr('title')} placement="top">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigateByRelationship(step.relationship(fr.relationships.navigate.name), loadModalCollectionByLink, loadPageContentLink, clearModalCollection);
              }}
            >
              <StepIcon active={step.isTruthy('highlighted')} icon={i + 1} />
            </a>
          </FDTooltip>
          {i !== steps.length - 1 ? <StepConnector orientation="horizontal" style={{ maxWidth: theme.spacing(3) }} /> : null}
        </Fragment>
      ))}
    </FDStack>
  );
}
